/**
 * Foundation/Core — Notification time formatters
 *
 * Formatter temporali generici per notifiche della Gruppo Impresa Suite.
 * Nessun riferimento a Product Pack, kind, o dominio.
 *
 * Basati sui formatter data ufficiali della Suite (`formatDateIT`, `formatDateTimeIT`).
 */
import { formatDateIT, formatDateTimeIT } from "@/foundation/formatting";

/**
 * Formatta un timestamp ISO in modo "umano" relativo:
 *  - < 60s   → "poco fa"
 *  - < 60min → "N min fa"
 *  - < 24h   → "N h fa"
 *  - altrimenti → data "gg/mm/aaaa"
 */
export function fmtRelative(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return "poco fa";
    if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} h fa`;
    return formatDateIT(iso.slice(0, 10));
  } catch (_) { return ""; }
}

/**
 * Formatta un timestamp ISO in formato completo "gg/mm/aaaa · HH:mm" (STANDARD Suite).
 * Fallback "—" per input invalidi.
 */
export function fmtDateTimeFull(iso) {
  return formatDateTimeIT(iso, "\u2014").replace(" ", " · ");
}
